import React, { useState } from 'react';
import { X, Book, Clock, User, Image, FileText, Download, Calendar, Mail, Phone, GraduationCap, Award, BookOpen } from 'lucide-react';
import { useNavigate } from 'react-router-dom';


// JSON Data Configuration
const libraryData = {
    colors: {
        primary: '#650033',
        secondary: '#FFC543',
        accent: '#024621'
    },

    header: {
        title: 'College Library',
        subtitle: 'Gateway to Knowledge and Excellence'
    },

    about: {
        mission: 'To support teaching, learning, research and publication of the Faculty, students and staff.',
        vision: 'To be a premiere learning resource center that supports academic excellence and innovation.',
        objectives: [
            'To build a rich and scholarly collection;',
            'To provide services according to the user needs.'
        ],
        description: 'Our library, established in 1963, has been the cornerstone of academic excellence at our institution. With over 15,000 books, numerous journals, and digital resources, we serve more than 1,000 students and many faculty members annually. Our modern facilities include dedicated study areas, research section , digital library sections, and a comprehensive archive of academic materials.'
    },

    librarian: {
        name: 'Dr. Srijani Kundu Ghosh',
        title: '',
        qualification: 'Ph.D. in Library Science',
        image: 'https://static.muoninfotech.com/./assets/ONUS/Screenshot 2026-01-09 at 10.32.38 AM.png',
        contact: {
            email: 'srisnh97@gmail.com',
            phone: '+91 9883597156',
            officeHours: 'Monday - Friday, 9:00 AM - 5:00 PM, Saturday, 10:00 AM - 1:30 PM'
        },
        cv: {
            education: [
                'Ph.D. in Library & Information Science, University of Calcutta',
                'M.Lib.I.Sc, University of Calcutta',

            ],
            experience: [
            ],
            specializations: ''
        }
    },

    timings: [
        { day: 'Monday - Friday', open: '10:00 AM', close: '5:00 PM', status: 'Open' },
        { day: 'Saturday', open: '10:00 AM', close: '1:30 PM', status: 'Open' },
        { day: 'Sunday', open: '-', close: '-', status: 'Closed' },
        { day: 'Public Holidays', open: '-', close: '-', status: 'Closed' }
    ],

    specialNote: '',

    bookCollection: [
        { department: "Hindi", booksPresent: 1024, issued: 19, transferred: 91, writeOff: 11, totalBooks: 1145 },
        { department: "English", booksPresent: 1349, issued: 12, transferred: 75, writeOff: 18, totalBooks: 1454 },
        { department: "Bengali", booksPresent: 1676, issued: 5, transferred: 61, writeOff: 19, totalBooks: 1761 },
        { department: "Urdu", booksPresent: 1437, issued: 4, transferred: 0, writeOff: 7, totalBooks: 1448 },
        { department: "Political Science", booksPresent: 820, issued: 8, transferred: 35, writeOff: 2, totalBooks: 865 },
        { department: "Economics", booksPresent: 505, issued: 7, transferred: 49, writeOff: 17, totalBooks: 578 },
        { department: "Education", booksPresent: 718, issued: 4, transferred: 48, writeOff: 12, totalBooks: 782 },
        { department: "Mathematics", booksPresent: 114, issued: 2, transferred: 0, writeOff: 0, totalBooks: 116 },
        { department: "Commerce", booksPresent: 2043, issued: 25, transferred: 37, writeOff: 6, totalBooks: 2111 },
        { department: "History", booksPresent: 795, issued: 8, transferred: 33, writeOff: 3, totalBooks: 839 },
        { department: "Persian", booksPresent: 139, issued: 0, transferred: 0, writeOff: 1, totalBooks: 140 },
        { department: "EVS", booksPresent: 5, issued: 0, transferred: 0, writeOff: 0, totalBooks: 5 },
        { department: "No Subject Defined", booksPresent: 1586, issued: 20, transferred: 117, writeOff: 0, totalBooks: 1723 },
        { department: "Donation", booksPresent: 3, issued: 0, transferred: 0, writeOff: 0, totalBooks: 3 },
        { department: "General", booksPresent: 196, issued: 1, transferred: 3, writeOff: 0, totalBooks: 200 },
        { department: "General Knowledge", booksPresent: 6, issued: 0, transferred: 0, writeOff: 0, totalBooks: 6 }
    ],

    otherResources: [
        { resource: 'Journals(EPW, Vivek jyoti, The Management accountant)', count: '04' },
        { resource: 'Newspapers (ei samay, Times of India, Pravat Khabar, Masriq)', count: '04' },

        { resource: 'Membership(ONUS)', count: '01' },
        { resource: 'Question Papers', count: '10' }
    ],

    opac: {
        title: 'ONOS Access Guide',
        description: ' Download the guide below to learn how to access and use the ONOS system effectively.',
        pdfUrl: 'https://static.muoninfotech.com/./assets/Library 2025/CGC_ Library _ONOS _Notice (1).pdf',
        links: [
            { name: 'OPAC Login', url: '#' },
            { name: 'User Manual', url: '#' },
            { name: 'Video Tutorial', url: '#' }
        ]
    },

    activities: [
        {
            year: '2025-26',
            pdfUrl: 'https://static.muoninfotech.com/./assets/Library 2025/Library report July 2025-till date.pdf'
        },
        {
            year: '2024-25',
            pdfUrl: 'https://static.muoninfotech.com/./assets/Library 2025/Library Report July 2024 to June 2025.pdf'
        },
        {
            year: '2023-24',
            pdfUrl: 'https://static.muoninfotech.com/./assets/Library 2025/library report for the session July 2023- June 2024.pdf'
        }
    ],

    gallery: [
        { id: 1, url: 'https://static.muoninfotech.com/./assets/library pic/WhatsApp Image 2026-01-10 at 01.55.40 (1).jpeg', title: 'Image001' },
        { id: 2, url: 'https://static.muoninfotech.com/./assets/library pic/WhatsApp Image 2026-01-10 at 01.55.40.jpeg', title: 'Image002' },
        { id: 3, url: 'https://static.muoninfotech.com/./assets/library pic/WhatsApp Image 2026-01-10 at 01.55.41.jpeg  ', title: 'Image003' },
        { id: 4, url: 'https://static.muoninfotech.com/./assets/library pic/WhatsApp Image 2026-01-10 at 01.57.37.jpeg', title: 'Image004' },

    ],

    footer: {
        copyright: '© 2026 College Library. All rights reserved.',
        contact: ''
    }
};

const Library = () => {
    const [selectedImage, setSelectedImage] = useState(null);
const navigate = useNavigate();
    const { colors, header, about, librarian, timings, specialNote, bookCollection, otherResources, opac, activities, gallery, footer } = libraryData;

    const getColor = (colorType) => {
        return colors[colorType] || colors.primary;
    };

    const calculateTotals = () => {
        return {
            booksPresent: bookCollection.reduce((sum, row) => sum + row.booksPresent, 0),
            issued: bookCollection.reduce((sum, row) => sum + row.issued, 0),
            transferred: bookCollection.reduce((sum, row) => sum + row.transferred, 0),
            writeOff: bookCollection.reduce((sum, row) => sum + row.writeOff, 0),
            totalBooks: bookCollection.reduce((sum, row) => sum + row.totalBooks, 0)
        };
    };

    return (
        <>
            <link
                href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/css/bootstrap.min.css"
                rel="stylesheet"
            />
            <style>{`
        .bg-primary-custom { background-color: ${colors.primary} !important; }
        .bg-secondary-custom { background-color: ${colors.secondary} !important; }
        .bg-accent-custom { background-color: ${colors.accent} !important; }
        .text-primary-custom { color: ${colors.primary} !important; }
        .text-accent-custom { color: ${colors.accent} !important; }
        .border-secondary-custom { border-color: ${colors.secondary} !important; }
        .gallery-item { cursor: pointer; transition: transform 0.2s; }
        .gallery-item:hover { transform: scale(1.05); }
        .activity-card { 
          transition: all 0.3s; 
          border-left: 5px solid;
        }
        .activity-card:hover { 
          box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15) !important;
          transform: translateY(-4px);
        }
        .resource-card { transition: transform 0.2s; }
        .resource-card:hover { transform: scale(1.05); }
        .avatar-img {
          width: 200px;
          height: 200px;
          object-fit: cover;
          border: 5px solid ${colors.secondary};
        }
        .table-hover tbody tr:hover { background-color: #fffbf0; }
        .modal-backdrop-custom {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0,0,0,0.75);
          z-index: 1050;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
                {/* Header */}
                <div className="bg-primary-custom text-white text-center py-5">
                    <Book size={64} className="mb-3" />
                    <h1 className="display-3 fw-bold mb-2">{header.title}</h1>
                    <p className="fs-4">{header.subtitle}</p>
                </div>

                <div className="container py-5">
                    {/* Section 1: Mission, Vision, Objectives & About */}
                    <div className="card shadow-lg mb-4">
                        <div className="card-body p-4">
                            <h2 className="text-primary-custom fw-bold mb-4">About Our Library</h2>

                            <div className="row g-3 mb-4">
                                <div className="col-md-6">
                                    <div className="card bg-accent-custom text-white h-100">
                                        <div className="card-body">
                                            <h3 className="fs-4 fw-bold mb-3">Mission</h3>
                                            <p className="mb-0">{about.mission}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="card bg-primary-custom text-white h-100">
                                        <div className="card-body">
                                            <h3 className="fs-4 fw-bold mb-3">Vision</h3>
                                            <p className="mb-0">{about.vision}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card mb-4" style={{ backgroundColor: 'rgba(255, 197, 67, 0.3)' }}>
                                <div className="card-body">
                                    <h3 className="fs-4 fw-bold text-primary-custom mb-3">Objectives</h3>
                                    <div className="d-flex flex-column gap-3">
                                        {about.objectives.map((obj, i) => (
                                            <div key={i} className="d-flex align-items-start gap-3">
                                                <Award size={20} style={{ color: colors.primary }} className="mt-1" />
                                                <p className="mb-0">{obj}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>

                            <p className="text-muted lh-lg">{about.description}</p>
                        </div>

                    </div>
                    {/* Section: Digital Library */}
                    <div className="card shadow-lg mb-4">
                        <div className="card-body p-4 d-flex justify-content-between align-items-center">

                            <h2 className="text-primary-custom fw-bold mb-0 d-flex align-items-center gap-2">
                                <BookOpen size={28} />
                              Calcutta Girls College Library Catlog
                            </h2>

                            <button
                                className="btn text-white"
                                style={{ backgroundColor: colors.accent }}
                                
                                onClick={() => window.location.href = 'https://cgcl.blacal.in/'}
                            >
                                View
                            </button>

                        </div>
                    </div>
                    {/* Section 2: Librarian Details */}
                    <div className="card shadow-lg mb-4">
                        <div className="card-body p-4">
                            <h2 className="text-primary-custom fw-bold mb-4">Librarian</h2>

                            <div className="row g-4">
                                <div className="col-md-4 text-center">
                                    <img
                                        src={librarian.image}
                                        alt={librarian.name}
                                        className="rounded-circle avatar-img mb-3"
                                    />
                                    <h3 className="fs-4 fw-bold">{librarian.name}</h3>
                                    <p className="text-muted mb-2">{librarian.title}</p>
                                    <span className="badge bg-accent-custom">{librarian.qualification}</span>
                                </div>

                                <div className="col-md-8">
                                    <div className="mb-4">
                                        <h4 className="fs-5 fw-bold text-primary-custom mb-3">Contact Information</h4>
                                        <div className="d-flex flex-column gap-2">
                                            <div className="d-flex align-items-center gap-2">
                                                <Mail size={20} style={{ color: colors.accent }} />
                                                <span>{librarian.contact.email}</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <Phone size={20} style={{ color: colors.accent }} />
                                                <span>{librarian.contact.phone}</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <GraduationCap size={20} style={{ color: colors.accent }} />
                                                <span>Office Hours: {librarian.contact.officeHours}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <h4 className="fs-5 fw-bold text-primary-custom mb-3">Curriculum Vitae</h4>
                                        <div className="small">
                                        </div>

                                        <a
                                            href="https://static.muoninfotech.com/./assets/CV/cv_Srijani Kundu Ghosh.pdf"
                                            download="Dhttps://static.muoninfotech.com/./assets/CV/cv_Srijani Kundu Ghosh.pdf"
                                            className="btn bg-primary-custom text-white mt-3"
                                            style={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}
                                        >
                                            <Download size={18} className="me-2" />
                                            Download Full CV
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 3: Library Timings */}
                    <div className="card shadow-lg mb-4">
                        <div className="card-body p-4">
                            <div className="d-flex align-items-center gap-3 mb-4">
                                <Clock size={40} style={{ color: colors.primary }} />
                                <h2 className="text-primary-custom fw-bold mb-0">Library Timings</h2>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-hover border border-2 border-secondary-custom">
                                    <thead className="bg-accent-custom text-white">
                                        <tr>
                                            <th>Day</th>
                                            <th>Opening Time</th>
                                            <th>Closing Time</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {timings.map((row, index) => (
                                            <tr key={index}>
                                                <td className="fw-bold">{row.day}</td>
                                                <td>{row.open}</td>
                                                <td>{row.close}</td>
                                                <td>
                                                    <span className={`badge ${row.status === 'Open' ? 'bg-accent-custom' : 'bg-secondary'}`}>
                                                        {row.status}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {specialNote && (
                                <div className="alert alert-warning mt-3" role="alert">
                                    <strong>Note:</strong> {specialNote}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Section 4: Book Collection */}
                    <div className="card shadow-lg mb-4">
                        <div className="card-body p-4">
                            <div className="d-flex align-items-center gap-3 mb-4">
                                <Book size={40} style={{ color: colors.primary }} />
                                <h2 className="text-primary-custom fw-bold mb-0">Library Collection</h2>
                            </div>

                            <h3 className="fs-5 fw-bold text-accent-custom mb-3">Department-wise Book Collection</h3>
                            <i>Library Collection report as per Libman Library Software on 06.11.2025</i>

                            <div className="table-responsive mb-4">
                                <table className="table table-hover border border-2 border-secondary-custom">
                                    <thead className="bg-primary-custom text-white">
                                        <tr>
                                            <th>Department</th>
                                            <th className="text-center">Books Present</th>
                                            <th className="text-center">Issued</th>
                                            <th className="text-center">Transferred</th>
                                            <th className="text-center">Write Off</th>
                                            <th className="text-center">Total Books</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bookCollection.map((row, index) => (
                                            <tr key={index}>
                                                <td className="fw-bold">{row.department}</td>
                                                <td className="text-center">{row.booksPresent}</td>
                                                <td className="text-center">{row.issued}</td>
                                                <td className="text-center">{row.transferred}</td>
                                                <td className="text-center">{row.writeOff}</td>
                                                <td className="text-center">{row.totalBooks}</td>
                                            </tr>
                                        ))}
                                        <tr className="bg-accent-custom text-white fw-bold">
                                            <td>TOTAL</td>
                                            <td className="text-center">{calculateTotals().booksPresent}</td>
                                            <td className="text-center">{calculateTotals().issued}</td>
                                            <td className="text-center">{calculateTotals().transferred}</td>
                                            <td className="text-center">{calculateTotals().writeOff}</td>
                                            <td className="text-center">{calculateTotals().totalBooks}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h3 className="fs-5 fw-bold text-accent-custom mb-3">Other Resources</h3>

                            <div className="row g-3">
                                {otherResources.map((resource, index) => (
                                    <div key={index} className="col-md-4">
                                        <div className={`card ${index % 2 === 0 ? 'bg-primary-custom' : 'bg-accent-custom'} text-white resource-card`}>
                                            <div className="card-body">
                                                <h4 className="fs-6 fw-bold">{resource.resource}</h4>
                                                <p className="display-6 fw-bold mb-0">{resource.count}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Section 5: OPAC PDF Download */}
                    <div className="card shadow-lg mb-4">
                        <div className="card-body p-4">
                            <div className="d-flex align-items-center gap-3 mb-4">
                                <FileText size={40} style={{ color: colors.primary }} />
                                <h2 className="text-primary-custom fw-bold mb-0">{opac.title}</h2>
                            </div>

                            <p className="text-muted mb-4">{opac.description}</p>

                            <div className="card" style={{ backgroundColor: 'rgba(255, 197, 67, 0.3)', border: `2px solid ${colors.primary}` }}>
                                <div className="card-body text-center">
                                    <a
                                        href={opac.pdfUrl}
                                        download
                                        className="btn bg-primary-custom text-white btn-lg"
                                    >
                                        <Download size={18} className="me-2" />
                                        Download ONOS Guide (PDF)
                                    </a>
                                </div>
                            </div>

                            <div className="card mt-3" style={{ backgroundColor: 'rgba(2, 70, 33, 0.2)' }}>
                                {/* <div className="card-body">
                  <p className="fw-bold mb-2">Quick Access Links:</p>
                  <div className="d-flex flex-wrap gap-3">
                    {opac.links.map((link, i) => (
                      <a key={i} href={link.url} className="text-primary-custom small text-decoration-underline">
                        {link.name}
                      </a>
                    ))}
                  </div>
                </div> */}
                            </div>
                        </div>
                    </div>

                    {/* Section 6: Library Activities */}
                    <div className="card shadow-lg mb-4">
                        <div className="card-body p-4">
                            <div className="d-flex align-items-center gap-3 mb-4">
                                <Calendar size={40} style={{ color: colors.primary }} />
                                <h2 className="text-primary-custom fw-bold mb-0">Library Activities</h2>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-hover border border-2 border-secondary-custom">
                                    <thead className="bg-primary-custom text-white">
                                        <tr>
                                            <th>Academic Year</th>
                                            <th className="text-center">Activities</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {activities.map((activity, index) => (
                                            <tr key={index}>
                                                <td className="fw-bold">{activity.year}</td>
                                                <td className="text-center">
                                                    <a
                                                        href={activity.pdfUrl}
                                                        download
                                                        className="btn btn-sm bg-accent-custom text-white"
                                                    >
                                                        <Download size={16} className="me-1" />
                                                        Download PDF
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Section 7: Gallery */}
                    <div className="card shadow-lg mb-4">
                        <div className="card-body p-4">
                            <div className="d-flex align-items-center gap-3 mb-4">
                                <Image size={60} style={{ color: colors.primary }} />
                                <h2 className="text-primary-custom fw-bold mb-0">Library Gallery</h2>
                            </div>

                            <div className="row g-3">
                                {gallery.map((image) => (
                                    <div key={image.id} className="col-md-4">
                                        <div className="card gallery-item" onClick={() => setSelectedImage(image)}>
                                            <img
                                                src={image.url}
                                                alt={image.title}
                                                className="card-img-top"
                                                style={{ height: '200px', }}
                                            />
                                            <div className="card-footer bg-accent-custom text-white text-center fw-bold">
                                                { }
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <footer className="bg-primary-custom text-white text-center py-4">
                    <p className="mb-2">{footer.copyright}</p>
                    <p className="mb-0">{footer.contact}</p>
                </footer>

                {/* Image Modal */}
                {selectedImage && (
                    <div className="modal-backdrop-custom" onClick={() => setSelectedImage(null)}>
                        <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header bg-primary-custom text-white">
                                    <h5 className="modal-title">{selectedImage.title}</h5>
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white"
                                        onClick={() => setSelectedImage(null)}
                                    ></button>
                                </div>
                                <div className="modal-body p-0">
                                    <img
                                        src={selectedImage.url}
                                        alt={selectedImage.title}
                                        className="w-100"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Library;